






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

@Component
export default class PatientAcquisitionExportationFrameWalkingContainerChartWalkingPhaseAverage extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  // -- CALCULS --------------------------------------------------------------------------------------------------------

  get strideLengthLeft(): number {
    const rsl = this.acquisition!.computed_data.left.aggregates.stride_length.avg;
    return parseFloat(rsl.toFixed(1));
  }

  get strideLengthRight(): number {
    const rsl = this.acquisition!.computed_data.right.aggregates.stride_length.avg;
    return parseFloat(rsl.toFixed(1));
  }
}
